import classNames from 'classnames';
import dynamic from "next/dynamic";
import {Suspense, memo} from "react";

import {usePrimaryMenuStore, useSearchOverlayStore, useStickyHeaderStore} from "@/lib/stores/layout";
import HeaderTop from '@/components/Header/HeaderTop';
import HeaderSubNav from '@/components/Header/HeaderSubNav';
import Loading from "@/components/Loading/Loading";
import HeaderBottom from "@/components/Header/HeaderBottom";

const HeaderNav = dynamic(() => import('./HeaderNav').then((mod) => mod.default));
const HeaderSearch = dynamic(() => import('./HeaderSearch').then((mod) => mod.default), {ssr: false});
const AnimatePresence = dynamic(() => import('framer-motion').then(mod => mod.AnimatePresence));

const Header = memo(function Header(
  {
    primaryMenu,
    subNavHtml,
    siteSettings,
    subMenuA,
    subMenuB,
    popularTags,
    enableShare = false
  }
) {
  const isSearchVisible = useSearchOverlayStore(state => state.visible);
  const isPrimaryMenuVisible = usePrimaryMenuStore(state => state.visible);
  // const isHeaderSticky = useStickyHeaderStore(state => state.sticky);

  return (
    <Suspense fallback={<Loading/>}>
      <header className={classNames(
        'text-center relative z-30 min-h-header',
        'sticky left-0 top-0 w-full admin-bar:top-[46px] md:admin-bar:top-8',
        'pointer-events-none [&>*]:pointer-events-auto' /* To allow void elements to be clicked through when header is sticky */
      )}>
        <HeaderTop enableShare={enableShare}/>

        <HeaderBottom {...{primaryMenu}}/>

        <AnimatePresence>
          {/* Can use isPrimaryMenuVisible here, as HeaderBottom has already covered links for SEO purposes */}
          {isPrimaryMenuVisible && <HeaderNav {...{primaryMenu, subMenuA, subMenuB, siteSettings, popularTags}}/>}
        </AnimatePresence>

        <AnimatePresence>
          {isSearchVisible && <HeaderSearch/>}
        </AnimatePresence>
      </header>

      {subNavHtml && <HeaderSubNav html={subNavHtml} />}
    </Suspense>
  );
});

export default Header;
